import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navigation from "@/components/mindscope/Navigation";
import Footer from "@/components/mindscope/Footer";
import CustomCursor from "@/components/mindscope/CustomCursor";
import SmoothScroll from "@/components/mindscope/SmoothScroll";
import ScrollToTop from "@/components/mindscope/ScrollToTop";
import ScrollProgress from "@/components/mindscope/ScrollProgress";
import AskMindscope from "@/components/mindscope/AskMindscope";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Vision from "@/pages/Vision";
import Leadership from "@/pages/Leadership";
import Services from "@/pages/Services";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll />
        <CustomCursor />
        <ScrollProgress />
        <ScrollToTop />
        <Navigation />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/vision" element={<Vision />} />
          <Route path="/leadership" element={<Leadership />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
        <AskMindscope />
      </BrowserRouter>
    </div>
  );
}

export default App;
